import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getCurrencySymbol } from './currency';

export const generateInvoice = (invoiceData) => {
  const {
    invoiceNumber,
    invoiceDate,
    dueDate,
    freelancer,
    client,
    project,
    incomeRecord,
    items = []
  } = invoiceData;

  const currencySymbol = getCurrencySymbol(freelancer.currency);
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(24);
  doc.setTextColor(79, 70, 229); // Indigo
  doc.text('INVOICE', 20, 20);
  
  // Invoice details
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text(`Invoice #: ${invoiceNumber}`, 20, 35);
  doc.text(`Date: ${invoiceDate}`, 20, 42);
  doc.text(`Due Date: ${dueDate}`, 20, 49);
  
  // From (Freelancer)
  doc.setFontSize(12);
  doc.text('From:', 20, 65);
  doc.setFontSize(10);
  doc.text(freelancer.name, 20, 72);
  doc.text(freelancer.email, 20, 79);
  
  // To (Client)
  doc.setFontSize(12);
  doc.text('Bill To:', 120, 65);
  doc.setFontSize(10);
  doc.text(client.name, 120, 72);
  if (client.company) doc.text(client.company, 120, 79);
  doc.text(client.email, 120, 86);
  if (client.phone) doc.text(client.phone, 120, 93);
  
  // Project details
  doc.setFontSize(11);
  doc.setTextColor(79, 70, 229);
  doc.text('Project Details', 20, 110);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text(`Project: ${project.title}`, 20, 118);
  doc.text(`Description: ${project.description.substring(0, 80)}`, 20, 125);
  
  // Items table
  const tableData = items.length > 0 ? items : [
    ['Payment for ' + project.title, '1', `${currencySymbol}${incomeRecord.amount.toFixed(2)}`, `${currencySymbol}${incomeRecord.amount.toFixed(2)}`]
  ];
  
  autoTable(doc, {
    startY: 135,
    head: [['Description', 'Quantity', 'Rate', 'Amount']],
    body: tableData,
    theme: 'striped',
    headStyles: { fillColor: [79, 70, 229] },
    margin: { left: 20, right: 20 }
  });
  
  // Total
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(12);
  doc.text('Total Amount:', 120, finalY);
  doc.setFontSize(14);
  doc.setTextColor(79, 70, 229);
  doc.text(`${currencySymbol}${incomeRecord.amount.toFixed(2)}`, 160, finalY);
  
  // Payment status
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  const status = incomeRecord.payment_status === 'received' ? 'PAID' : 'PENDING';
  const statusColor = incomeRecord.payment_status === 'received' ? [16, 185, 129] : [245, 158, 11];
  doc.setTextColor(...statusColor);
  doc.text(`Status: ${status}`, 20, finalY);
  
  // Footer
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text('Thank you for your business!', 20, 280);
  doc.text('For any queries, please contact: ' + freelancer.email, 20, 285);
  
  return doc;
};

export const downloadInvoice = (invoiceData, filename) => {
  const doc = generateInvoice(invoiceData);
  doc.save(filename || `invoice_${invoiceData.invoiceNumber}.pdf`);
};
